export const SESSION_STARTED = 'SESSION_STARTED';
export const SESSION_FINISHED = 'SESSION_FINISHED';
export const SIGN_IN = 'SIGN_IN';
export const SOCIAL_SIGN_IN = 'SOCIAL_SIGN_IN';
export const RESTORE_PASSWORD_EMAIL = 'RESTORE_PASSWORD_EMAIL';
export const SIGN_UP = 'SIGN_UP';
export const CREATE_PASSWORD = 'CREATE_PASSWORD';
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';
export const NOTIFY_SESSION_CHANGED = 'NOTIFY_SESSION_CHANGED';
export const RELOAD_USER = 'RELOAD_USER';
export const SEND_VERIFICATION_EMAIL = 'SEND_VERIFICATION_EMAIL';
export const EMAIL_VERIFIED = 'EMAIL_VERIFIED';
